/**
 * filter
 * 공통 필터
 */
export const state = () => ({
  devicesTreeData: void 0
})

export const mutations = {
  initStore (state) {
    state.devicesTreeData = void 0
  },
  devicesTreeData (state, devicesTreeData) {
    state.devicesTreeData = devicesTreeData
  }
}

export const actions = {
  async getDevicesTreeData ({ commit, rootState }, {
    isLoading,
    onlyGroupYn,
    onlyConfigYn,
    tamsYn,
    slaveYn,
    exceptMonNodeYn,
    onlyPolicyMngYn,
    onlyTamsYn,
    bluemaxModelType,
    onlyUnregisteredYn,
    treeType = 0,
    menuId = 0,
    menuSubId = void 0,
    targetId = 0,
    deviceSubType = true,
    onlySdwanLicYn = 0
  } = {}) {
    let res = { code: 'ok', result: {} }
    try {
      if (onlyUnregisteredYn) {
        res = await this.$axios.$get('/api/pm/use-firewall/device')
        if (res.code === 'ok') commit('devicesTreeData', res.result)
        return res
      }
      /**
       * 지원 장비 적용 우선 순서
       * 1. param으로 설정된 deviceModelType 값을 적용.
       * 2. menu에 설정된 support deviceModelType 값을 적용(보류).
       */
      // 1. param 값을 적용.
      const deviceModelParam = []
      const deviceModelType = _.map(bluemaxModelType.split(','), _.trim)

      if (!_.isEmpty(deviceModelType)) {
        _.forEach(deviceModelType, value => {
          // 장비 모델 타입 (미설정 NULL, 장비 모델 유형 9 MF2, 10 MFI, 11 MFD, 12 MF2 AE, 20 Bluemax NGF, 21 Bluemax IPS, 22 Bluemax WIPS, 23 Bluemax ADS)
          switch (value) {
            case 'ngf':
              deviceModelParam.push(20)
              break
            case 'ips':
              deviceModelParam.push(21)
              break
            case 'wips':
              deviceModelParam.push(22)
              break
            case 'mf2':
              deviceModelParam.push(9)
              break
            case 'mfi':
              deviceModelParam.push(10)
              break
            case 'mfd':
              deviceModelParam.push(11)
              break
            case 'ads':
              deviceModelParam.push(23)
              break
            default:
              break
          }
        })
        // device_model_type이 있을 경우, tams_yn 설정이 적용 안되는 SQL문 보완.
        if (!_.isEmpty(deviceModelParam) && tamsYn) {
          deviceModelParam.push(0)
        }
      }

      const params = {
        only_group_yn: onlyGroupYn ? 1 : 0,
        only_config_yn: onlyConfigYn ? 1 : 0,
        tams_yn: tamsYn ? 1 : 0,
        slave_yn: slaveYn ? 1 : 0,
        except_mon_node_yn: exceptMonNodeYn ? 1 : 0,
        only_policy_mng_yn: onlyPolicyMngYn ? 1 : 0,
        only_tams_yn: onlyTamsYn ? 1 : 0,
        event_code_yn: 1,
        device_model_type: deviceModelParam.length > 0 ? deviceModelParam.join(',') : null,
        tree_type: treeType,
        device_sub_type: deviceSubType ? 1 : 0,
        only_sdwan_lic_yn: onlySdwanLicYn ? 1 : 0
      }

      // CM, 메뉴 트리
      if (treeType === 1) {
        // params.menu_id = menuId // CM 메뉴
        const _menuId = menuId === 0 ? this.getters['common/multirw/thisMenu'].code : menuId
        if (!_.isNil(menuSubId)) {
          params.menu_id = Number(`${_menuId}${menuSubId}`)
        } else {
          params.menu_id = _menuId
        }
        params.target_id_val = targetId // 설정 ID
      }

      // 2. menu에서 support device 설정된 값을 적용.
      // TAMS 장비 미포함시 적용.
      // let modelType = this.getters['common/multirw/thisMenuSupportInfo'].device || null
      // if (!params.tams_yn && _.isEmpty(params.device_model_type) && !_.isEmpty(modelType)) {
      //   params.device_model_type = _.join(modelType)
      // }
      // console.log(params.device_model_type)

      res = await this.$axios.$get('/api/sm/devices-tree', {
        params,
        loading: isLoading,
        ignoreHaPrefix: true
      })
      if (res.code === 'ok') commit('devicesTreeData', res.result)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
